





















import { Filter } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { Facets } from '../../../models';
import AddClassToSlot from '../add-class-to-slot';

@Component({
  components: {
    AddClassToSlot
  }
})
export default class SelectedFilters extends Vue {

  @Prop({ required: true })
  selectedFilters: Filter[];

  compulsoryFacets: Facets;

  removeFilter(filter: Filter) {
    this.$x.emit(EVENTS.FilterClicked, filter);
  }
}
